import { put, select, takeEvery } from 'redux-saga/effects'

import {
  deleteOrganizationUserBulkForMicroactionTable,
  selectUsersPage,
  fetchUsersTrigger,
  fetchUsersByStatusTrigger,
} from 'store/entities/organizations/actions'
import { getOrganizationUsersCurrentPage, getUsersOnPageList } from 'store/entities/organizations/selectors'

export default function* deleteOrganizationUserBulkSaga() {
  // @ts-ignore
  yield takeEvery(
    deleteOrganizationUserBulkForMicroactionTable.success.toString(),
    handleDeleteOrganizationUserBulkSaga
  )
}

export function* handleDeleteOrganizationUserBulkSaga() {
  const currentPage = yield select(getOrganizationUsersCurrentPage)
  const usersOnPageList = yield select(getUsersOnPageList)
  let page = currentPage
  try {
    if (usersOnPageList.size === 0) {
      page = currentPage === 0 ? currentPage : currentPage - 1
      yield put(selectUsersPage(page))
    }
    yield put(fetchUsersTrigger({ page }))
    yield put(fetchUsersByStatusTrigger())
  } catch (badResponse) {
    console.log(badResponse)
  }
}
